namespace('compass.account');


compass.account.SendConfirmationWidget = compass.defineWidget(function SendConfirmationWidget(options) {
	var me = this;
	var d = jQuery.dom.getContext(this);

	var $j = jQuery;
	var _settings = options;
	var _inputs = {};
	
	var _drawEmailInput = function () {
		_inputs.email = d.input({
			className: "emailInput",
			name: "email",
			type: "email",
			autcomplete: 'off',
			'aria-label' : 'Email Address',
			'data-parsley-required': 'true',
			'data-parsley-error-message': 'A valid email address is required',
			'data-parsley-type': 'email'
		}).val(_settings.email);

		var field = d.fieldLabelPair({
			className : 'emailField',
			label : 'Email Address:'
		}, [_inputs.email]);


		return field;
	};
	
	
	var _render = this.render = function(widgetElem) {

		var sendConfoButton = d.button({className:'button sendConfirmationButton', 'aria-role':'link', tabindex: 0}, 'Send Confirmation');
		sendConfoButton.activate(function(){	
			compass.loading.start($j('.sendConfirmationButton').empty(), { color : '#FFFFFF' });
			me.trigger('SendConfirmationWidget.sendConfirmation', { email : _inputs.email.val()});
		});

		var sendConfoDiv = d.div({className:'sendConfirmationDiv'});
		sendConfoDiv.append(d.h3({className:'sendConfirmationHeaderDiv'}, 'Email a new confirmation'),
				_drawEmailInput(),
				sendConfoButton,
						d.div({'className':'floatClear'})
		);
		
		widgetElem.append(sendConfoDiv);
	};
	
}, {
	WUID: "crap",
	widgetName: 'SendConfirmationWidget',
	email : ''
});
